import moment from 'moment';
import { currencyTypeEnum, tabletVisanetEnum, addressTypeEnum, jobReasonEnum, subReasonsEnum, affiliationTypeEnum } from '../enums';
import { calculateHorario, calculateUbigeo } from './shared';

export var mapRequestAffiliation = function mapRequestAffiliation(_ref) {
    var form = _ref.form,
        commercialTariffResult = _ref.commercialTariffResult,
        preliminaryCheckResult = _ref.preliminaryCheckResult,
        previousCommerceCode = _ref.previousCommerceCode,
        isNotBimoney = _ref.isNotBimoney,
        username = _ref.username,
        getters = _ref.getters;

    var NombreMulticomercio = "",
        CodigoPadre = "",
        TipoTrabajo = void 0,
        SubMotivo = void 0;
    var MCCI_NOM = form.businessData.commerceData.commercialBusiness.Description;
    // let { MCCI, MCCN, currency, orden_servicio } = commercialTariffResult
    var MCCI = commercialTariffResult.mcci,
        MCCN = commercialTariffResult.mccn,
        Moneda = commercialTariffResult.currency,
        paymentData = commercialTariffResult.paymentData;
    // let { Moneda, paymentData } = currency

    var NombreComercial = getters.commercialName;

    switch (Number(form.osvType.osvType)) {
        // individual
        case 1:
            if (isNotBimoney) {
                TipoTrabajo = jobReasonEnum.INSTALACION;
                SubMotivo = subReasonsEnum.NINGUNO;
            } else {
                NombreMulticomercio = NombreComercial;
                if (Moneda === currencyTypeEnum.DOLARES) {
                    //'Dólares'
                    TipoTrabajo = jobReasonEnum.REGISTRO;
                    SubMotivo = subReasonsEnum.MULTICOMERCIO;
                    CodigoPadre = previousCommerceCode;
                } else {
                    //'Soles'
                    TipoTrabajo = jobReasonEnum.INSTALACION;
                    SubMotivo = subReasonsEnum.MULTICOMERCIO;
                }
            }

            break;
        // multicomercio
        case 2:
            NombreMulticomercio = NombreComercial;
            SubMotivo = subReasonsEnum.MULTICOMERCIO_MISMO_RUC;
            TipoTrabajo = jobReasonEnum.INSTALACION;
            break;
        // código hijo
        case 3:
            // NombreMulticomercio = (orden_servicio && orden_servicio.NombreMulticomercio) || '' // TODO: obtener el nombre comercial del codigo de comercio
            NombreMulticomercio = commercialTariffResult.multicommerceName || '';
            CodigoPadre = form.osvType.commercialCode;
            SubMotivo = subReasonsEnum.MULTICOMERCIO_MISMO_RUC;
            TipoTrabajo = jobReasonEnum.REGISTRO;
            break;
    }

    var _form$businessSchedul = form.businessSchedule,
        schedule = _form$businessSchedul.schedule,
        startTime = _form$businessSchedul.startTime,
        endTime = _form$businessSchedul.endTime;

    var RazonSocial = form.rucValidation.businessName.replace(/\./g, '').replace(/\ñ/g, 'n').replace(/\&/g, 'y').replace(/\'/g, '').replace(/\"/g, '');

    // hack for accents
    if (String.prototype.normalize) RazonSocial = RazonSocial.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    var TipoAfiliacion = form.membershipType.type;
    var FechaDesde = TipoAfiliacion === affiliationTypeEnum.TEMPORAL ? form.membershipType.startDate : "";
    var FechaHasta = TipoAfiliacion === affiliationTypeEnum.TEMPORAL ? form.membershipType.endDate : "";

    var representantes = [{
        Cargo: '',
        FechaNacimiento: form.legalRepresentativeData.birthdate,
        NumeroDocumento: form.legalRepresentativeData.documentNumber,
        TipoDocumento: (form.legalRepresentativeData.documentType || { Code: '' }).Code,
        Email: form.legalRepresentativeData.email,
        ApellidoPaterno: form.legalRepresentativeData.paternalName,
        Nombres: form.legalRepresentativeData.firstName,
        TipoRepresentante: 'R',
        ApellidoMaterno: form.legalRepresentativeData.maternalName,
        Nacionalidad: '',
        TelefonoCelular: form.legalRepresentativeData.cellPhone,
        isCopyLegal: 0,
        wasModified: false
    }, {
        Cargo: 'OTR',
        FechaNacimiento: form.legalRepresentativeData.birthdate,
        NumeroDocumento: form.legalRepresentativeData.documentNumber,
        TipoDocumento: (form.legalRepresentativeData.documentType || { Code: '' }).Code,
        Email: form.legalRepresentativeData.email,
        ApellidoPaterno: form.legalRepresentativeData.paternalName,
        Nombres: form.legalRepresentativeData.firstName,
        TipoRepresentante: 'V',
        ApellidoMaterno: form.legalRepresentativeData.maternalName,
        Nacionalidad: '',
        TelefonoCelular: form.legalRepresentativeData.cellPhone,
        isCopyLegal: 0,
        wasModified: false
    }, {
        Cargo: 'OTR',
        FechaNacimiento: '',
        NumeroDocumento: '',
        TipoDocumento: '',
        Email: form.installationSchedule.email,
        ApellidoPaterno: form.installationSchedule.paternalLastname,
        Nombres: form.installationSchedule.name,
        TipoRepresentante: 'V',
        ApellidoMaterno: form.installationSchedule.maternalLastname,
        Nacionalidad: '',
        TelefonoCelular: form.installationSchedule.phone,
        isCopyLegal: 0,
        wasModified: false
    }];

    return {
        objIncidencia: {
            direcciones: [{
                Lote: form.businessData.administrativeAddress.allotment,
                Mz: form.businessData.administrativeAddress.block,
                NombreConglomerado: "",
                TipoConglomeradoId: "",
                Interior: form.businessData.administrativeAddress.interior,
                TipoInteriorId: (form.businessData.administrativeAddress.interiorType || { Code: "" }).Code,
                PlusCode: form.businessData.administrativeAddress.plusCode,
                Km: form.businessData.administrativeAddress.km,
                Numero: form.businessData.administrativeAddress.numberOfRoad,
                Telefono1: form.businessData.administrativeAddress.cellPhone || "",
                Telefono2: form.businessData.administrativeAddress.landline || "",
                Referencia: form.businessData.administrativeAddress.reference,
                TipoViaId: (form.businessData.administrativeAddress.typeOfRoad || { Code: "" }).Code,
                TypeUrbanHabilitation: form.businessData.administrativeAddress.typeUrbanHabilitation,
                UrbanHabilitation: form.businessData.administrativeAddress.urbanHabilitation,
                TipoHorario: "01", //hourType
                Horario: calculateHorario(schedule, startTime, endTime),
                NombreVia: form.businessData.administrativeAddress.nameOfRoad,
                TipoDireccion: addressTypeEnum.ADMINISTRATIVE,
                Ubigeo: form.ubigeo,
                NombreHabUrbana: "",
                TipoHabUrbanaId: "",
                sameAddress: false
            }, {
                Lote: form.businessData.commercialAddress.allotment,
                Mz: form.businessData.commercialAddress.block,
                NombreConglomerado: "",
                TipoConglomeradoId: "",
                Interior: form.businessData.commercialAddress.interior,
                TipoInteriorId: (form.businessData.commercialAddress.interiorType || { Code: "" }).Code,
                PlusCode: form.businessData.commercialAddress.plusCode,
                Km: form.businessData.commercialAddress.km,
                Numero: form.businessData.commercialAddress.numberOfRoad,
                Telefono1: form.businessData.commercialAddress.cellPhone || "",
                Telefono2: form.businessData.commercialAddress.landline || "",
                Referencia: form.businessData.commercialAddress.reference,
                TipoViaId: (form.businessData.commercialAddress.typeOfRoad || { Code: "" }).Code,
                TypeUrbanHabilitation: form.businessData.commercialAddress.typeUrbanHabilitation,
                UrbanHabilitation: form.businessData.commercialAddress.urbanHabilitation,
                TipoHorario: "01", //hourType,
                Horario: calculateHorario(schedule, startTime, endTime),
                NombreVia: form.businessData.commercialAddress.nameOfRoad,
                TipoDireccion: addressTypeEnum.COMMERCIAL,
                Ubigeo: form.ubigeo,
                NombreHabUrbana: "",
                TipoHabUrbanaId: "",
                sameAddress: form.businessData.adminCommerEquals
            }],
            FechaAsignacion: form.processInitDate,
            Canal_ID: tabletVisanetEnum.CANAL_ID,
            closingDate: "",
            RazonSocial: RazonSocial,
            TipoConexionPOS: "",
            Deuda: "",
            MCCI: MCCI,
            RubroPincipal: MCCI_NOM,
            solicitud: {
                CuentaBancaria: paymentData.accountNumber,
                TipoCuentaId: paymentData.accountType,
                BancoId: paymentData.bankName,
                dispositivos_de_captura: [{
                    key: tabletVisanetEnum.CAPTURE_DEVICE_ID,
                    parent: tabletVisanetEnum.SERVICE_ID
                }],
                CambioRS: "false",
                CodigoComercio: "",
                // ComisionCredito: commercialTariffResult.solicitud.ComisionCredito, // form.quotation.creditCardCommission,
                ComisionCredito: commercialTariffResult.creditCommission || 3.99, // form.quotation.creditCardCommission,
                Moneda: Moneda,
                // ComisionDebito: commercialTariffResult.solicitud.ComisionDebito, // form.quotation.debitCardCommission,
                ComisionDebito: commercialTariffResult.debitCommission || 2.99, // form.quotation.debitCardCommission,
                FechaDesde: FechaDesde,
                AgrupacionComercial: "",
                MCCI: MCCI,
                MCCI_NOM: MCCI_NOM,
                MCCN: MCCN,
                MCCN_NOM: "",
                // ComercioNuevo: preliminaryCheckResult && preliminaryCheckResult.solicitud ? preliminaryCheckResult.solicitud.ComercioNuevo : 'true',
                ComercioNuevo: 'true',
                NumCuotasInstal: form.quotation.taxQuota, //diferente
                TipoAfiliacion: TipoAfiliacion,
                PtoVenta: "false",
                CodigoAnterior: "",
                NombreComercialAnterior: "",
                // Segmento: preliminaryCheckResult && preliminaryCheckResult.solicitud ? preliminaryCheckResult.solicitud.Segmento : "",
                Segmento: '',
                ServicioId: tabletVisanetEnum.SERVICE_ID,
                FechaHasta: FechaHasta,
                // CostoInstalacion: parseFloat(commercialTariffResult.solicitud.CostoInstalacion)
                CostoInstalacion: parseFloat(commercialTariffResult.installationConst)
            },
            MCCN: MCCN,
            // num_incidencia: preliminaryCheckResult.num_incidencia,
            num_incidencia: form.idTransaction,
            // Usuario: tabletVisanetEnum.USER, //diferent
            Usuario: username, //diferent
            Ubigeo: form.ubigeo,
            representantes: representantes,
            Ruc: form.rucValidation.ruc,
            checkList: {
                RangoEdad: "3",
                Color: "Offline",
                PuertaCentroComercial: "true",
                Nota: "-1",
                NumeroLocales: "3",
                ExisteComercioCalle: "3",
                VentasMes: "4",
                AntiguedadComercio: "3",
                Ubigeo: form.ubigeo
            },
            orden_servicio: {
                FechaAcordada: moment().format('DD/MM/YYYY'), //S	No manejamos este dato, debemos poner los valores que indicas en duro?	Debe ser el mismo dato del horario de atención del Comercio en la Dirección Comercial
                HoraAcordada: moment().format('hh:mm A'), //S	No manejamos este dato, debemos poner los valores que indicas en duro?	Debe ser el mismo dato del horario de atención del Comercio en la Dirección Comercial
                DatosConfiguracion: [],
                TipoConexion: form.posSelected.TipoConexion,
                DireccionGateway: "",
                ProveedorInternet: "0",
                DireccionIP: "",
                TipoIP: "0",
                InstalacionPost: "FALSE",
                NombreMulticomercio: NombreMulticomercio,
                TipoTrabajo: TipoTrabajo,
                CodigoPadre: CodigoPadre,
                CentralTelefonica: "0",
                NumeroCentralTelef: "",
                Telefono: "",
                ProveedorTelefonia: "0",
                HorarioAtencion: [],
                ComparteLinea: "0",
                Senalizacion: "042",
                SubMotivo: SubMotivo,
                DireccionMascara: "",
                NroPOS: parseInt(form.quotation.posNumber, 10) || 1
            },
            // EstadoId: preliminaryCheckResult ? (preliminaryCheckResult.EstadoId || "") : "",
            EstadoId: '',
            Paso: '6',
            AsociacionComercial: "",
            NombreComercial: NombreComercial,
            // IdMotivo: preliminaryCheckResult ? (preliminaryCheckResult.IdMotivo || 0) : 0,
            IdMotivo: 0,
            offlineStep: 2,
            offline: false,
            callingOfflineStep: 0
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/affiliation.js
// module id = ./src/mappers/affiliation.js
// module chunks = 34